import defaultConfig from "@/config";
import axios from "axios";

let config: any;
if (process.env.NODE_ENV != "development" && (window as any).getClientConfiguration!) {
  const clientConfig = (window as any).getClientConfiguration();
  if (clientConfig && !clientConfig.missing) {
    config = clientConfig;
    config.isClientConfig = true;
  } else console.error("client side configuration hook returned invalid object.", clientConfig);
} else console.error("client side configuration hook not found.");
if (!config) {
  let devConfig: any = {};
  try {
    const fetched = await import(`@/config/devConfigs/${process.env.VUE_APP_CURRENT_DEV_CONFIG}.config`);
    devConfig = fetched.default;
  } catch (error) {
    console.warn("specific dev config could not be loaded - using default", error);
  }
  config = Object.assign(defaultConfig, devConfig);
}

let uri = config.apiUrl;
if (uri && uri[uri.length - 1] == "/") uri = uri.substring(0, uri.length - 1);
axios.defaults.baseURL = config.apiUrl = uri;

export default config;
